import "./Hero.css"
import react from "react"
import Aos from "aos"
import logo from "./images/CSI-Logo.png"
import "aos/dist/aos.css"

const Hero = () => {
  react.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])
  return (
    <header className="hero" data-aos="fade-up">
      <img src={logo} alt="Logo" />
      <div className="heroLogoTxt">
        <span id="heroLogoTxt1">CLUB OF</span>
        <span id="heroLogoTxt2">SUSTAINABILITY</span>
        <span id="heroLogoTxt3"> & </span>
        <span id="heroLogoTxt4">INNOVATION</span>
      </div>
    </header>
  )
}

export default Hero
